import { render } from "./B2bLoginPasswordFormRedes.vue?vue&type=template&id=1a58f45e&scoped=true&lang=pug"
import script from "./B2bLoginPasswordFormRedes.vue?vue&type=script&lang=js"
export * from "./B2bLoginPasswordFormRedes.vue?vue&type=script&lang=js"

import "./B2bLoginPasswordFormRedes.vue?vue&type=style&index=0&id=1a58f45e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a58f45e"]])

export default __exports__